<template lang="pug">
  div.cloth(:class="{'active': act == true}")
    button(@click="change")
      img(src="@/assets/ico_cloth.svg")
      img(src="@/assets/ico_cloth_on.svg")
</template>

<script>
import store from '../../stores';
export default{
  name: 'Clothing',
  data () {
    return {
      act: false
    };
  },
  props: {
    flg: Boolean
  },
  methods: {
    change () {
      if (this.flg) {
        this.act = false;
      } else {
        this.act = true;
      }
      store.commit('setClothes', this.act);
      this.$emit('change', this.act);
    }
  },
  created () {
    this.act = this.flg;
  }
};
</script>

<style lang="stylus" scoped>
  .cloth
    margin-right 10px
    button
      padding 0
      width 33px
      height 33px
      border 1px solid #dddddd
      border-radius 3px
      background-color #ffffff
      img
        pointer-events none
      img:nth-child(1)
        display inline
      img:nth-child(2)
        display none
    &.active
      button
        background-color #2E7C80
        img:nth-child(1)
          display none
        img:nth-child(2)
          display inline

</style>



// WEBPACK FOOTER //
// src/components/status/Clothing.vue